import React from 'react';
import classNames from 'classnames';

import ScreenReaderMessage from '../accessibility/screen-reader-message';

import { ButtonType } from './button-enums';
import { ButtonProps } from './button-types';

const Button: React.FC<ButtonProps> = ({
  children,
  type = 'button',
  href,
  target,
  className,
  disabled,
  buttonType = ButtonType.PRIMARY,
  modified,
  ...props
}) => {
  return href && !disabled ? (
    <a
      href={href}
      className={classNames(buttonType, className, {
        'button-large': modified,
      })}
      {...(target && {
        target: target,
        rel: 'noreferrer',
      })}
      {...props}
    >
      {children}
      {target && <ScreenReaderMessage />}
    </a>
  ) : (
    <button
      type={type}
      className={classNames(
        buttonType,
        className,
        {
          'button-large': modified && buttonType !== ButtonType.LINK,
        },
        {
          'button-small': modified && buttonType === ButtonType.LINK,
        }
      )}
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
